<div class="niq-logo-div">
  <img src="assets/images/NIQ-BASES-logo-white.svg" alt="NielsenIQ Studio"/>
</div>
